export const licenseKey: string =
  'ewogICJmb3JtYXQiOiAxLAogICJjdXN0b21lcklkIjogIjAzMDdmODM0LTlmY2QtNDgzMC1iMTA5LTkwZmNmMWU5ODkxZiIsCiAgIm1heFZlcnNpb25BbGxvd2VkIjogMjUyCn0=.nUwCeSYwM5w5u80VvkCkX7U5/PQ0OVzDvu317AtfirJcwguwxSrFU7beplhKKzlyTPryyfI7YZv1CPEluU2FAbWjQFpWs4KSJmk4t49zC53AvUr6Lekbq2pg9yCRgI4aAvHHJg==';
